import type { ControlState } from "../../sim";

/**
 * Scripted "attract mode" input used until keyboard control lands (P3.1): each ship
 * thrusts in bursts, weaves, and fires both weapons now and then.
 */
export function demoControls(tick: number, players: number): ControlState[] {
	return Array.from({ length: players }, (_, i) => {
		const t = tick + i * 137;
		return {
			thrust: t % 90 < 25,
			left: t % 240 < 40,
			right: t % 240 >= 120 && t % 240 < 150,
			fireLaser: t % 200 < 12,
			fireMissile: t % 300 === 0,
		};
	});
}
